import { useEffect, useState } from "react";


export const PublisherInfoHook = () => {
    const [publisherName, setPublisherName] = useState('');
    const [userName, setUserName] = useState('');
    const [typeOfLogin, setTypeOfLogin] = useState('');
    const [publisherID, setPublisherID] = useState(null);

    const setPublisherInfoFromStorage = () => {
        if (sessionStorage.getItem('pnk')) setPublisherName(sessionStorage.getItem('pnk'))
        if (sessionStorage.getItem('unk')) setUserName(sessionStorage.getItem('unk'))
        if (sessionStorage.getItem('tk')) setTypeOfLogin(sessionStorage.getItem('tk'))
    }

    return {
        state: { publisherName, userName, typeOfLogin, publisherID },
        actions: { setPublisherID, setPublisherInfoFromStorage }
    }
}